import {
	appliedFiltersSidebarAtom,
	selectedSidebarFiltersAtom,
} from '@pages/VendorsSearch/containers/FilterPills/components/Sidebar/atoms';
import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';

export const useInitializeSelectedSidebarFilters = () => {
	const setSelectedSidebarFilters = useSetAtom(selectedSidebarFiltersAtom);
	const appliedFiltersSidebar = useAtomValue(appliedFiltersSidebarAtom);

	return useCallback(() => {
		const appliedSidebarFilterIds = appliedFiltersSidebar.flatMap(
			(appliedSidebarFilter) => appliedSidebarFilter.getAppliedFacetIds(),
		);
		setSelectedSidebarFilters(appliedSidebarFilterIds);
	}, [appliedFiltersSidebar, setSelectedSidebarFilters]);
};
